import React from 'react';

import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {RuleConditionTypesEnum} from '../ruleConditionModel';

/*
 * Types.
 */

interface RuleConditionIconProps {
  id: RuleConditionTypesEnum;
}

/*
 * Component.
 */

export const RuleConditionIcon = ({id}: RuleConditionIconProps) => <Icon name={getIconName(id)} />;

/*
 * Helpers.
 */

function getIconName(id: string): IconName {
  switch (id) {
    case RuleConditionTypesEnum.INBOX_IS:
    case RuleConditionTypesEnum.INBOX_IN:
    case RuleConditionTypesEnum.INBOX_BELONGS_TO:
    case RuleConditionTypesEnum.ALL_INDIVIDUAL_INBOXES:
    case RuleConditionTypesEnum.ALL_SHARED_INBOXES:
    case RuleConditionTypesEnum.CHANNEL_IS:
    case RuleConditionTypesEnum.CHANNEL_IN:
      return 'inboxFilled';

    case RuleConditionTypesEnum.TIME_IS:
    case RuleConditionTypesEnum.DATE_IS:
    case RuleConditionTypesEnum.IS_SNOOZED:
    case RuleConditionTypesEnum.UNREPLIED_AFTER:
    case RuleConditionTypesEnum.UNASSIGNED_AFTER:
    case RuleConditionTypesEnum.DELAY_SINCE_TRIGGER:
    case RuleConditionTypesEnum.DURING_BUSINESS_HOURS:
    case RuleConditionTypesEnum.OUTSIDE_BUSINESS_HOURS:
      return 'clock';

    case RuleConditionTypesEnum.ADDED_TAG_IS:
    case RuleConditionTypesEnum.HAS_TAG:
    case RuleConditionTypesEnum.HASNT_TAG:
    case RuleConditionTypesEnum.HAS_NO_TAGS:
    case RuleConditionTypesEnum.HAS_TAG_IN:
    case RuleConditionTypesEnum.HASNT_TAGS:
      return 'tagFilled';

    case RuleConditionTypesEnum.REMOVED_TAG_IS:
      return 'untag';

    case RuleConditionTypesEnum.CONTACT_IN_GROUP:
    case RuleConditionTypesEnum.CONTACT_NOT_IN_GROUP:
    case RuleConditionTypesEnum.CUSTOM_ATTRIBUTE_BOOLEAN:
    case RuleConditionTypesEnum.CUSTOM_ATTRIBUTE_DATETIME:
    case RuleConditionTypesEnum.CUSTOM_ATTRIBUTE_NUMBER:
    case RuleConditionTypesEnum.CUSTOM_ATTRIBUTE_STRING:
    case RuleConditionTypesEnum.CUSTOM_ATTRIBUTE_TEAMMATE:
    case RuleConditionTypesEnum.MESSAGE_FROM:
    case RuleConditionTypesEnum.MESSAGE_TO:
    case RuleConditionTypesEnum.MESSAGE_CC:
    case RuleConditionTypesEnum.MESSAGE_BCC:
    case RuleConditionTypesEnum.MESSAGE_ANY_RECIPIENT:
    case RuleConditionTypesEnum.MESSAGE_TO_CC:
      return 'contactsFilled';

    case RuleConditionTypesEnum.MESSAGE_TYPE:
      return 'composeFilled';

    case RuleConditionTypesEnum.IS_ARCHIVED:
      return 'archiveFilled';

    case RuleConditionTypesEnum.SUBJECT:
    case RuleConditionTypesEnum.MESSAGE_BODY:
      return 'channelEmail';

    case RuleConditionTypesEnum.COMMENT_AUTHOR:
    case RuleConditionTypesEnum.COMMENT_BODY:
      return 'chatFilled';

    case RuleConditionTypesEnum.MESSAGE_HEADERS:
    case RuleConditionTypesEnum.MESSAGE_HTML_BODY:
      return 'code';

    case RuleConditionTypesEnum.LANGUAGE:
      return 'planet';

    case RuleConditionTypesEnum.MENTIONS:
      return 'mention';

    case RuleConditionTypesEnum.ASSIGNEE_IS:
    case RuleConditionTypesEnum.ASSIGNEE_IN:
    case RuleConditionTypesEnum.ASSIGNEE_NOT_IN:
      return 'assignFilled';

    case RuleConditionTypesEnum.IS_UNASSIGNED:
      return 'unassign';

    case RuleConditionTypesEnum.DAY_IS:
      return 'calendarFilled';

    case RuleConditionTypesEnum.MESSAGE_DIRECTION:
      return 'arrowCurvedRight';

    case RuleConditionTypesEnum.HAS_ATTACHMENTS:
    case RuleConditionTypesEnum.ATTACHMENT_NAME_CONTAINS:
    case RuleConditionTypesEnum.ATTACHMENT_EXTENSION_IS:
      return 'attachment';

    case RuleConditionTypesEnum.HAS_NO_ATTACHMENTS:
      return 'noAttachment';

    case RuleConditionTypesEnum.COMPARE_EXPRESSION_BOOLEAN:
    case RuleConditionTypesEnum.COMPARE_EXPRESSION_NUMBER:
    case RuleConditionTypesEnum.COMPARE_EXPRESSION_STRING:
    case RuleConditionTypesEnum.COMPARE_EXPRESSION_DATETIME:
    case RuleConditionTypesEnum.COMPARE_EXPRESSION_TEAMMATE:
    case RuleConditionTypesEnum.COMPARE_EXPRESSION_OTHER:
      return 'sparkles';

    case RuleConditionTypesEnum.ACCOUNT_CUSTOM_ATTRIBUTE_TEAMMATE:
    case RuleConditionTypesEnum.ACCOUNT_CUSTOM_ATTRIBUTE_BOOLEAN:
    case RuleConditionTypesEnum.ACCOUNT_CUSTOM_ATTRIBUTE_DATETIME:
    case RuleConditionTypesEnum.ACCOUNT_CUSTOM_ATTRIBUTE_NUMBER:
    case RuleConditionTypesEnum.ACCOUNT_CUSTOM_ATTRIBUTE_STRING:
      return 'briefcaseFilled';

    default:
      return 'moveActivityFilled';
  }
}
